<div fxLayout="row wrap">
  <div class="teranet-padding" fxFlex="100" fxLayout="column">
    <Teranet-PageTitle [PageTitle]="'Client Information'"></Teranet-PageTitle>
    <div class="mat-elevation-z4">
      <div fxFlex="100">
        <div fxLayout="column" fxLayoutAlign="center stretch">
          <Teranet-ClientTitle [ClientTitle]="'Client List'" [IconName]="'list'"></Teranet-ClientTitle>
        </div>
        <div fxLayout="column" fxLayoutAlign="center stretch">
          <div *ngIf="!Readonly" fxLayout="row wrap" fxLayoutAlign="end">
            <div class="icon-button">
              <button mat-button (click)="add()">
                <div class="btnicon">
                  <fa-icon icon="plus" id="plus" class="fa-lg" matTooltipPosition="above"></fa-icon>
                </div>
                <div class="btntext">Add</div>
              </button>
            </div>
          </div>
          <div class="teranet-padding-relative" fxFlex="100">
            <ngx-spinner [fullScreen]="false"
                         type="ball-clip-rotate-multiple"
                         bdColor="rgba(51,51,51,0.8)"
                         size="medium"
                         color="#fff"></ngx-spinner>
            <Teranet-CustomizedGrid [clearFiltersBtn]="false"
                                    [data]="clients"
                                    [gridName]="'client-list'"
                                    [gridSettings]="gridSettings"
                                    [initialGridSettings]="gridDefaultSettings()"
                                    [isExportExcel]="false"
                                    [kendoGridToolbar]="false"
                                    [pageName]="'client-list'"
                                    [resetBtn]="false"></Teranet-CustomizedGrid>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
